module.exports = __webpack_public_path__ + "img/solidWaste02.1dc5f237.png";